<template>
  <el-table
    class="k-users-list"
    :data="users"
    style="width: 100%"
    :row-class-name="tableRowClassName"
  >
    <el-table-column
      class="k-users-list__value"
      prop="_id"
      label="id"
      width="180"
    >
    </el-table-column>

    <el-table-column
      class="k-users-list__value"
      prop="email"
      label="E-mail"
    >
    </el-table-column>

    <el-table-column
      class="k-users-list__value"
      prop="name"
      label="Имя"
    >
    </el-table-column>

    <el-table-column
      class="k-users-list__value"
      prop="surname"
      label="Фамилия"
    >
    </el-table-column>

   <el-table-column label="Action" width="170">
      <template slot-scope="scope">
        <el-tooltip content="Челленджи" placement="top">
          <el-button @click="handleChallenges(scope.row)" type="info" icon="el-icon-s-order" circle size="mini"></el-button>
        </el-tooltip>
        <el-tooltip content="Загрузить фото" placement="top">
          <el-button @click="handleUpload(scope.row)" type="warning" icon="el-icon-upload" circle size="mini"></el-button>
        </el-tooltip>
        <el-tooltip content="Редактировать" placement="top">
          <el-button @click="handleEdit(scope.row)" type="success" icon="el-icon-edit" circle size="mini"></el-button>
        </el-tooltip>
        <el-tooltip content="Удалить" placement="top">
          <el-button @click="handleDelete(scope.row)" type="danger" icon="el-icon-delete" circle size="mini"></el-button>
        </el-tooltip>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
/**
 * Component: k-users-list - Отображает список пользователей

*
* @version 1.0.0
*/


import formatDate from '@/util/formatDate';

export default {
  name: 'k-users-list',

  props: {
    // Массив всех точек
    users: {
      type: Array,
    },
  },

  methods: {
    // Класс для стрки, используется для расскарски строк таблицы в разные цвета
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 2 === 0) {
        return 'warning-row';
      } else {
        return 'success-row';
      }
      return '';
    },

    // Редактирование точки
    handleEdit(data) {
      this.$emit('edit', data._id)
    },

    // Удаление точки
    handleDelete(data) {
      this.$emit('delete', data._id)
    },

    // Загрузить фото
    handleUpload(data) {
      this.$emit('updateImage', data._id)
    },

    // Загрузить фото
    handleChallenges(data) {
      this.$emit('challenges', data._id)
    },

    // Форматирование даты
    formatDate,
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.k-users-list {
  $this: &;

  margin-bottom: $vp;

  &__value {
    font-size: 10px;
  }
}
</style>
